import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RiderService } from './rider-service';
import {
	buildRiderActivityDateRequest,
	mapRiderAvailabilityItems,
	RiderActivityDateRequest,
	RiderActivityRow,
	toRiderHistoryPoints,
	RiderHistoryPoint
} from '@shared/rider-activity-history/rider-activity-history';

export interface RiderLocationHistoryView {
	riderName: string;
	riderImage: string;
	points: RiderHistoryPoint[];
}

@Injectable({ providedIn: 'root' })
export class RiderActivityHistoryService {
	constructor(private riderService: RiderService) {}

	buildDateRequest(riderId: number, startDate?: Date | string | null, endDate?: Date | string | null): RiderActivityDateRequest {
		return buildRiderActivityDateRequest(riderId, startDate, endDate);
	}

	loadAvailabilities(
		riderId: number,
		startDate: Date | string | null | undefined,
		endDate: Date | string | null | undefined,
		messageService: MessageService
	): Promise<RiderActivityRow[]> {
		return this.riderService
			.getHistoryRiderAvailabilities(this.buildDateRequest(riderId, startDate, endDate), messageService)
			.then(data => {
				if (!data?.Success) {
					throw new Error(data?.ErrorMessage || 'Unable to load activity');
				}
				return mapRiderAvailabilityItems(data.Items);
			});
	}

	loadLocationHistory(
		riderId: number,
		startDate: Date | string | null | undefined,
		endDate: Date | string | null | undefined,
		messageService: MessageService
	): Promise<RiderLocationHistoryView> {
		return this.riderService
			.getRiderLocationHistory(this.buildDateRequest(riderId, startDate, endDate), messageService)
			.then(data => {
				if (!data?.Success) {
					throw new Error(data?.ErrorMessage || 'Unable to load location history');
				}

				const history = data.RiderPointHistory || {};
				return {
					riderName: history.RiderFullName || '',
					riderImage: history.RiderImageUrl || '',
					points: toRiderHistoryPoints(history.Points)
				};
			});
	}

	exportAppHistory(
		riderId: number,
		startDate: Date | string | null | undefined,
		endDate: Date | string | null | undefined,
		messageService: MessageService
	): Promise<any> {
		return this.riderService.exportRiderAppHistory(
			this.buildDateRequest(riderId, startDate, endDate),
			messageService
		);
	}
}
